import React from 'react';
import * as QuickSightEmbedding from 'amazon-quicksight-embedding-sdk';
import { AppLayout } from 'AWS-UI-Components-React';
import { getJSClient } from '../js_client';

import { NavigationHeaderStyle } from '../../styles/common_styles.jsx';
import { QsParameters } from '../navigation/qs_parameters';

export class QsEmbedder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formSubmitted: false,
      quicksighterror: false,
      dashboardurl: '',
      loading: true,
      error: null,
      parametersPayload: {},
      dashboard: null,
    };
    this.payload = {};
  }
  componentDidMount = () => {
    this.client = getJSClient();
    this.initialClientTasks();
  };

  initialClientTasks = () => {
    this.client.getDashboardUrl(this.onDashboardUrlSuccess, this.onDashboardUrlFailure, this.props.payload);
  };
  embedDashboard = (embedUrl) => {
    let containerDiv = document.getElementById('dashboardContainer');
    let options = {
      url: embedUrl,
      container: containerDiv,
      parameters: this.state.parametersPayload,
      scrolling: 'yes',
      height: '1500vh',
      width: '100%',
    };
    console.log('Options:' + options);
    let dashboard = QuickSightEmbedding.embedDashboard(options);
    this.setState({ dashboard: dashboard });
    dashboard.on('error', this.onDashboardLoadFailure);
    dashboard.on('load', this.onDashboardLoadSuccess);
  };

  renderDashboard() {
    if (this.state.quicksighterror) {
      return this.renderError();
    }
    let loadingDiv = document.getElementById('loadingDiv');
    if (loadingDiv) {
      loadingDiv.display = 'none';
    }
  }
  renderLoading() {
    return (
      <div id="loadingDiv" className="sk-wave">
        <div className="sk-rect sk-rect1"></div>
        <div className="sk-rect sk-rect2"></div>
        <div className="sk-rect sk-rect3"></div>
        <div className="sk-rect sk-rect4"></div>
        <div className="sk-rect sk-rect5"></div>
      </div>
    );
  }
  renderError() {
    return <div>Uh oh: {this.state.error.message}</div>;
  }

  onDashboardUrlSuccess = (response) => {
    console.log(response);
    let embedUrl = response.dashboardurl;
    this.setState({
      dashboardurl: embedUrl,
      quicksighterror: false,
      loading: false,
      error: null,
    });
    this.embedDashboard(embedUrl);
  };
  onDashboardUrlFailure = (err) => {
    console.log(err);
    this.setState({ quicksighterror: true, loading: false, error: err });
  };
  onDashboardLoadSuccess = (response) => {
    console.log(response);
    this.setState({ quicksighterror: false, loading: false, error: null });
  };
  onDashboardLoadFailure = (err) => {
    console.log(err);
    this.setState({ quicksighterror: true, loading: false, error: err });
  };
  getCallbackPayload = (payload) => {
    var shipMonth = payload.year + payload.month;
    payload['shipmonth'] = shipMonth;
    this.setState({ formSubmitted: true, parametersPayload: payload });
    this.state.dashboard.setParameters(payload);
    console.log(payload);
  };

  content = () => {
    return (
      <div>
        <div id="dashboardContainer">{this.state.loading ? this.renderLoading() : this.renderDashboard()}</div>
      </div>
    );
  };

  navigation = () => {
    return (
      <div data-navigation-level="0">
        <div className="website-navigation-title" style={NavigationHeaderStyle}>
          <b>
            <font size="4">Report Parameters </font>
          </b>
        </div>
        <QsParameters callback={this.getCallbackPayload} identity={this.props.identity} />
      </div>
    );
  };

  render() {
    return (
      <div>
        <AppLayout
          className="awsui-util-no-gutters"
          content={this.content()}
          navigation={this.navigation()}
          navigationHide={true}
          toolsHide={true}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contra_cogs/qsembedder.jsx